module.exports = __webpack_public_path__ + "img/missionday-carousel.d74959cc.jpg";